/** Student portal route helpers — keep sidebar + login targets aligned. */
export const STUDENT_HOME = "/Student/dashboard";

export function isStudentHomePath(pathname) {
    return pathname === "/" || pathname === STUDENT_HOME;
}

export function isStudentFeesPath(pathname) {
    return pathname.startsWith("/Student/fees");
}

export function isStudentResultsPath(pathname) {
    return (
        pathname.startsWith("/Student/results") ||
        pathname.startsWith("/Student/report-card") ||
        pathname.startsWith("/Student/transcript")
    );
}
